// extracted by mini-css-extract-plugin
export default {"menu":"components-MainMenu-themes-PP-desktop-styles__menu--xoQU0"};